import {
  FETCH_CONFIGURATION_FAIL,
  FETCH_CONFIGURATION_REQUEST,
  SET_COMMON_CONFIGURATION,
} from '../../constants/configuration';
import NetworkError from '../../../utils/NetworkError';

export const fetchConfigurationRequest = () => ({
  type: FETCH_CONFIGURATION_REQUEST,
});
export const fetchConfigurationFail = (payload) => ({
  type: FETCH_CONFIGURATION_FAIL,
  payload,
  error: true,
});
export const fetchConfigurationFailByTimeout = () => {
  const payload = new NetworkError(503);

  return fetchConfigurationFail(payload);
};

export const setCommonConfiguration = (payload) => ({
  type: SET_COMMON_CONFIGURATION,
  payload,
});
